import axios from 'axios';
import { config } from '@/config';

const instance = axios.create({
  baseURL: 'https://n8n-new.hostgator.com.br/webhook/ai-agents/chat/',
  headers: {
    brand: config.COUNTRY,
    'Content-Type': 'application/json',
  },
});

const n8n = {
  instance,
  get: ({ url, headers }) => instance.get(url, { headers }),
  post: ({ url, headers, data }) => instance.post(url, data, { headers }),
  delete: ({ url, headers }) => instance.delete(url, { headers }),
};

export default n8n;
